import React from 'react';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import FrassinettiLogo from '../assets/frassinetti.jpg';
import VicenteLogo from '../assets/vicente.jpeg';
import AsisLogo from '../assets/asis.jpeg';
import VideoColegios from '../assets/video1.mp4';
import VideoColegiosDos from '../assets/video2.mp4';

const CollegesPage = () => {
  const colegios = [
    {
      id: 'paola-frassinetti',
      nombre: 'Paola Frassinetti',
      logo: FrassinettiLogo,
      referencia: 'Colegio aliado en formación STEM y liderazgo para estudiantes.',
    },
    {
      id: 'san-vicente-de-paul',
      nombre: 'San Vicente de Paul',
      logo: VicenteLogo,
      referencia: 'Institución participante en iniciativas de empoderamiento y habilidades laborales.',
    },
    {
      id: 'francisco-de-asis',
      nombre: 'Francisco de Asís',
      logo: AsisLogo,
      referencia: 'Comunidad educativa que impulsa el desarrollo integral de niñas y jóvenes.',
    },
  ];

  return (
    <div className="min-h-screen">
      <section className="py-20 bg-gradient-to-br from-fhk-cyan-50 to-fhk-orange-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Colegios donde estamos <span className="text-fhk-cyan-600">impactando</span>
            </h1>
          </div>
          <div className="colleges-content">
            <p className="text-lg text-gray-700">
              Empoderar a niñas y jóvenes a través de formación STEM, liderazgo y habilidades laborales para alcanzar una igualdad de género, oportunidades laborales y comunidades más prósperas, apoyadas por alianzas sólidas.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div className="bg-gray-50 rounded-3xl p-6 md:p-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Colegios participantes</h2>
              <div className="space-y-6">
                {colegios.map((colegio) => (
                  <div key={colegio.id} className="flex items-start gap-4 border-b border-gray-200 pb-5 last:border-b-0">
                    <img
                      src={colegio.logo}
                      alt={`Logo ${colegio.nombre}`}
                      className="w-14 h-14 md:w-16 md:h-16 object-contain rounded-lg"
                    />
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">{colegio.nombre}</h3>
                      <p className="text-gray-600 mt-1">{colegio.referencia}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Carrusel de actividades</h2>
              <Gallery />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Video</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <video className="w-full h-96 md:h-[27rem] lg:h-[30rem] object-cover" controls preload="metadata">
                <source src={VideoColegios} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
              </video>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <video className="w-full h-96 md:h-[27rem] lg:h-[30rem] object-cover" controls preload="metadata">
                <source src={VideoColegiosDos} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
              </video>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CollegesPage;
